export default {
  MuiButton: {
    root: {
      textTransform: 'none',
      fontSize: 16,
      lineHeight: '20px',
      fontWeight: 700,
      height: 48,
      borderRadius: 4,
    },
    containedPrimary: {
      backgroundColor: '#26A69A',
      color: '#FFFFFF',
      '&:hover': {
        backgroundColor: '#4DB6AC',
        boxShadow: 'none',
        '@media (hover: none)': {
          backgroundColor: '#26A69A',
          color: '#FFFFFF',
        },
      },
      '@media (hover: none)': {
        backgroundColor: '#26A69A',
        color: '#FFFFFF',
      },
    },
    textPrimary: {
      color: '#26A69A',
      '&:hover': {
        backgroundColor: 'transparent',
        textDecoration: 'underline',
      },
    },
    containedSecondary: {
      color: '#000000',
      backgroundColor: '#FFFFFF',
      border: [1, 'solid', '#26A69A'],
      '&:hover': {
        backgroundColor: '#FFFFFF',
        border: [1, 'solid', '#009688'],
        boxShadow: 'none',
        '@media (hover: none)': {
          backgroundColor: '#FFFFFF',
        },
      },
    },
    contained: {
      boxShadow: 'none',
      backgroundColor: '#26A69A',
      color: '#FFFFFF',
      padding: 16,
      boxSizing: 'border-box',
      '&:active': {
        boxShadow: 'none',
      },
      '&.Mui-disabled': {
        backgroundColor: '#e0e0e0',
        border: 'none',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/layouts/ThemeProvider/overrides/Button.js